import { Component, OnInit } from '@angular/core';

import { SmartSmsService } from 'src/app/core/api/services';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
  selector: 'brand-select-search',
  templateUrl: './base/base-select-search-template.html',
  standalone: true,
  imports: [BaseSelectSearchModule],
})
export class BrandSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  constructor(protected currentService: SmartSmsService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'name';

    if (!this.label) this.label = 'common.deviceBrands';
  }

  getItemsApi() {
    this.currentService
      .smartSmsGetBrands()
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
